export default __webpack_public_path__ + "static/media/Languages.da0b5c13.svg";